import React from "react";
import Page from "../../Components/Page/Page";
import { withRouter } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { LinkText } from "../About/About";

const EC_EUROPA_LINK = "https://ec.europa.eu/consumers/odr/";
const ELEKTRO_ALTGERAETE_REGISTER_LINK =
  "https://www.bmuv.de/themen/wasser-ressourcen-abfall/kreislaufwirtschaft/statistiken/elektro-und-elektronikaltgeraete";
const GESAMT_LINK =
  "http://www.gesetze-im-internet.de/bundesrecht/urhg/gesamt.pdf";

const LegalNotice = () => {
  const { t } = useTranslation();

  return (
    <Page>
      <h1 className="settings-hdr">{t("LegalNotice")}</h1>

      <div className="about-info legal-notice-info">LZE GmbH</div>
      <div className="about-info">Frauenweiherstr. 15</div>
      <div className="about-info legal-notice-info">91058 Erlangen</div>
      <div className="about-info">{t(`CommercialRegister`)}: HRB 16647</div>
      <div className="about-info">{t(`RegisterCourt`)}: Fürth</div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`RepresentedBy`)}
      </h3>
      <div className="about-info">Dr. Christian Forster</div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`ContactUs`)}
      </h3>
      <div className="about-info legal-notice-info">
        {t(`Phone`)}: +49 9131 92894 80
      </div>
      <div className="about-info">E-Mail: contact@lze-innovation.de</div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`SalesTaxID`)}
      </h3>
      <div className="about-info">{t(`SalesTaxDesc`)}</div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`EuDisputeResolution`)}
      </h3>

      <div className="about-info">
        <Trans
          i18nKey="EuDisputeResolutionDesc"
          components={{
            link1: <LinkText to={EC_EUROPA_LINK} title="My link1" />,
          }}
        />
      </div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`ConsumerDispute`)}
      </h3>
      <div className="about-info">{t(`ConsumerDisputeResolutionDesc`)}</div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`RegistrationNumber`)}
      </h3>
      <div className="about-info legal-notice-info">
        WEEE reg. no. DE 68509724
      </div>
      <div className="about-info">
        <Trans
          i18nKey="RegistrationNumberDesc"
          components={{
            link1: (
              <LinkText
                to={ELEKTRO_ALTGERAETE_REGISTER_LINK}
                title="My link1"
              />
            ),
          }}
        />
      </div>

      <h3 className="about-info" style={{ marginBottom: 12 }}>
        {t(`Copyright`)}
      </h3>
      <div className="about-info">
        <Trans
          i18nKey="CopyrightDesc"
          components={{
            link1: <LinkText to={GESAMT_LINK} title="My link1" />,
            link2: <LinkText to={GESAMT_LINK} title="My link2" />,
          }}
        />
      </div>
    </Page>
  );
};

export default withRouter(LegalNotice);
